import { Component, OnInit, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GoogleAnalyticsClickEventDirective } from '@lx/shared/google-analytics';
import { ONLINE_COURSES_WAYFINDER_BANNER_COOKIE } from '../../constants';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { getLocale } from '@lx/shared/i18n';
import { getOnlineQTBaseUrl } from '../../utils';

@Component({
  standalone: true,
  selector: 'lx-online-courses-wayfinder-banner',
  templateUrl: './online-courses-wayfinder-banner.component.html',
  styleUrls: ['./online-courses-wayfinder-banner.component.scss'],
  imports: [GoogleAnalyticsClickEventDirective],
})
export class OnlineCoursesWayfinderBannerComponent implements OnInit {
  private readonly cookieService = inject(CookieService);
  private readonly locale = getLocale();

  protected visibility = false;
  protected onlineCoursesUrl = '';
  protected dataLayerEventName = GoogleAnalyticsEventEnum.OnlineCoursesWayfinderBannerClick;

  ngOnInit(): void {
    if (this.isBannerEnabled()) {
      const baseUrl = getOnlineQTBaseUrl();
      if (baseUrl) {
        const onlineCoursesUrl = new URL(baseUrl, window.location.origin);
        onlineCoursesUrl.searchParams.set('locale', this.locale);
        this.onlineCoursesUrl = onlineCoursesUrl.toString();
        this.visibility = true;
      }
    }
  }

  private isBannerEnabled(): boolean {
    if (!this.cookieService.check(ONLINE_COURSES_WAYFINDER_BANNER_COOKIE)) {
      return false;
    }

    return this.cookieService.get(ONLINE_COURSES_WAYFINDER_BANNER_COOKIE) === 'true';
  }

  protected handleBannerClick(): void {
    if (this.onlineCoursesUrl) {
      window.location.href = this.onlineCoursesUrl;
    }
  }
}
